import React, { Component } from 'react';
import { ConsequencesHeadingProps } from 'app/area/codetable/list/list-renderer/types';
import styles from './severity-heading.scss';

export class SeverityHeading extends Component<ConsequencesHeadingProps> {

  public render() {

    const { screenPayload: { screenProps }, translation } = this.props;

    return <div className={styles.headingContainer}>
      <div className={styles.defaultColumn}>
        {screenProps.listCategoryLabel(translation)}
      </div>
      <div className={styles.defaultColumn}>{screenProps.listLevelLabel(translation)}</div>
      <div className={styles.defaultColumn}>{translation.sequence}</div>
      <div className={styles.fixedColumn} />
    </div>;
  }
}
